import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const { ShortDateTime, Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const UnloadingPointDesktop = ({
  className,
  deliveryAddress,
  siteContact,
  ticket,
  unloading,
  arriveJob,
  endUnloading,
  isStandAloneTicket,
}) => {
  return (
    <Styled className={cn('unloading-point', className)}>
      <Subtitle>
        <Translate stringId="unloadingPoint" data-testid="unloadingPointLabel" />
      </Subtitle>
      <div>
        <Translate stringId="siteAddress" data-testid="siteAddressLabel" /> :{' '}
        <span data-testid="deliveryAddressValue">{deliveryAddress}</span>{' '}
        {deliveryAddress && deliveryAddress.trim() !== '' && isStandAloneTicket && (
          <a
            href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(deliveryAddress)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="getDirectionsLink"
          >
            <Translate stringId="getDirections" data-testid="getDirectionsLabel" />
          </a>
        )}
      </div>
      <div>
        <Translate stringId="customer" data-testid="customerLabel" /> :{' '}
        <span data-testid="customerName">
          {ticket?.customerParty?.id}/{ticket?.customerParty?.name}
        </span>
      </div>

      <div>
        <Translate stringId="siteContactName" data-testid="siteContactNameLabel" /> :{' '}
        <span data-testid="siteContactName">{siteContact.name}</span>
      </div>
      <div>
        <Translate stringId="siteContactPhoneNumber" data-testid="customerPhoneNumberLabel" /> :{' '}
        <span data-testid="customerPhoneNumber">
          {' '}
          <a href={`tel:${siteContact.phone}`}>{siteContact.phone}</a>{' '}
        </span>
      </div>
      {ticket?.customData?.ticketType !== 'PMP' && (
        <div>
          <Translate stringId="unloadingScheduleStart" data-testid="unloadingScheduleStartLabel" />
          {': '}
          <span style={{ whiteSpace: 'nowrap' }} data-testid="unloadingScheduleStart">
            <ShortDateTime date={unloading} />
          </span>
        </div>
      )}
      <div>
        <Translate stringId="agreedUnloading" data-testid="agreedUnloadingLabel" />
        {': '}
        <span style={{ whiteSpace: 'nowrap' }} data-testid="agreedUnloading">
          <ShortDateTime date={arriveJob} />
          {' - '}
          <ShortDateTime date={endUnloading} />
        </span>
      </div>
    </Styled>
  );
};

export default UnloadingPointDesktop;
